var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextBold2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "-7 -7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1v16H.5 8m0-8H5m0-8H.5M5.5 9C7.433 9 9 7.21 9 5S7.433 1 5.5 1H5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9c1.934 0 3.501-1.79 3.501-4s-1.567-4-3.5-4h-3M5 17V1M8 17c1.933 0 3.5-1.79 3.5-4S9.933 9 8 9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17H10c1.933 0 3.5-1.79 3.5-4S11.933 9 10 9H7.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgTextBold2;